import {CSSProperties, FC} from 'react';


export interface IIconTestDriveNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTestDriveNissan: FC<IIconTestDriveNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 4c-4.411 0-8 3.588-8 8s3.589 8 8 8 8-3.589 8-8-3.588-8-8-8Zm1.483 10.076a2.454 2.454 0 0 0-.121.674c-.452-.23-.901-.35-1.357-.35h-.002c-.458 0-.91.12-1.365.352a2.474 2.474 0 0 0-.12-.676c-.578-1.662-2.742-2.074-4.174-2.347-.146-.028-.312-.06-.468-.092.796-.553 3.229-1.138 6.124-1.237 2.895.099 5.328.683 6.124 1.236-.156.032-.322.064-.468.092-1.432.273-3.596.685-4.173 2.348ZM12 5.6c2.755 0 5.102 1.754 6.003 4.2-1.843-.755-4.506-.952-5.977-1h-.052c-1.472.048-4.134.245-5.976 1 .9-2.446 3.247-4.2 6.002-4.2Zm-6.277 7.638.322.064c1.07.203 2.688.512 2.962 1.3.11.317.09 1.034-.942 2.435a6.404 6.404 0 0 1-2.342-3.798v-.001Zm3.848 4.68c.935-1.166 1.667-1.752 2.429-1.752v-.01c.768 0 1.507.565 2.454 1.753a6.368 6.368 0 0 1-4.883.009Zm6.365-.882c-1.032-1.401-1.052-2.118-.942-2.434.275-.79 1.891-1.098 2.962-1.301.11-.021.217-.042.322-.064a6.409 6.409 0 0 1-2.342 3.8Z" clipRule="evenodd" />
        </svg>
    );
};
